import React from "react";
import {react} from "mobx";
import {inject, observer} from "mobx-react";
import {Component} from "react/lib/ReactBaseClasses";
import _ from 'lodash';
import PropTypes from "prop-types";
import loading from '../../../assets/images/ajax-loader.gif';

@inject("store")
@observer
class LoadingBlockFields extends Component {

    static propTypes = {
        carregando: PropTypes.bool
    };

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={this.props.carregando ? 'blockContent' : ''}>
                {this.props.children}
            </div>
        );
    }
}

export {LoadingBlockFields}